module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-boxed"
  }, [_c('div', {
    staticClass: "pexeto-recent-posts rp-list"
  }, [_c('h3', {
    staticClass: "rp-title"
  }, [_c('router-link', {
    attrs: {
      "to": "/articles"
    }
  }, [_vm._v(_vm._s(_vm.$t("article")))])], 1), _vm._v(" "), _c('div', {
    staticClass: "pb-10"
  }, [_c('v-expansion-panel', _vm._l((_vm.articles), function(item) {
    return _c('v-expansion-panel-content', {
      key: item.Id,
      scopedSlots: _vm._u([{
        key: "header",
        fn: function() {
          return [_c('h3', [_vm._v(_vm._s(item.Name))])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [(item.Thumbnail) ? _c('div', {
      staticClass: "rp-date"
    }, [_c('img', {
      staticClass: "wp-post-image",
      attrs: {
        "src": item.Thumbnail,
        "alt": item.Name
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rp-info"
    }, [_c('h3', {
      staticClass: "pt-0"
    }, [_c('router-link', {
      attrs: {
        "to": item.SeName,
        "title": item.Name
      }
    }, [_vm._v(_vm._s(item.Name))])], 1), _vm._v(" "), _c('div', {
      staticClass: "rp-cat"
    }, [_c('router-link', {
      attrs: {
        "to": item.SeName,
        "title": item.Short
      }
    }, [_vm._v(_vm._s(item.Short))])], 1)])])], 1)], 1)
  }), 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc3a8f3e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/HomeArticle.vue
// module id = 489
// module chunks = 1